import z from 'zod';
import { createFileRoute } from '@tanstack/react-router';
import { Incidents } from '@/features/incidents';
import { requireActiveSubscription } from '@/lib/middleware';


const incidentsSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  status: z.string().optional().catch(''),
  severity: z.string().optional().catch(''),
  incidentType: z.string().optional().catch(''),
  search: z.string().optional().catch(''),
})

export const Route = createFileRoute('/_authenticated/_organization/incidents/')({
  beforeLoad: async () => requireActiveSubscription(),
  component: Incidents,
  validateSearch: incidentsSearchSchema,
})
